import * as d3 from 'd3-scale-chromatic'

function calculatePoint(i, intervalSize, colorRangeInfo) {
  let { colorStart, colorEnd, useEndAsStart } = colorRangeInfo
  return (useEndAsStart
    ? (colorEnd - (i * intervalSize))
    : (colorStart + (i * intervalSize)))
}

function interpolateColors(dataLength, colorScale, colorRangeInfo) {
  let { colorStart, colorEnd } = colorRangeInfo
  let colorRange = colorEnd - colorStart
  let intervalSize = colorRange / dataLength
  let i, colorPoint

  let colorArray = []
  for (i = 0; i < dataLength; i++) {
    colorPoint = calculatePoint(i, intervalSize, colorRangeInfo)
    colorArray.push(colorScale(colorPoint))
  }

  return colorArray
}

function generateColor(dataLength) {
  let colorArray = []

  if (!dataLength) {
    return colorArray
  }
  const colorScale = d3.interpolateCool
  const colorRangeInfo = {
    colorStart: 0.25,
    colorEnd: 1,
    useEndAsStart: false
  }

  colorArray.push(...interpolateColors(dataLength, colorScale, colorRangeInfo))

  return colorArray
}

export default {
  generateColor
}
